<template>
  <v-dialog
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    width="800"
    @keydown.esc="closeDialog()"
  >
    <v-card>
      <v-card-title class="title pb-0">
        Client Notifications for {{ currentCompany.name }}
      </v-card-title>
      <v-card-text class="subheading darkgrey--text">
        <v-alert
          :value="true"
          outline
          block
          :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
          color="primary"
          class="text-xs-left"
        >
          If <b>Get All Owners' Signature</b> option is selected when sending a
          {{ projectViewEnabled ? 'project' : 'questionnaire' }}, all owners
          with
          <b
            >{{ projectViewEnabled ? 'Project' : 'Questionnaire' }} Signature</b
          >
          on will be required to sign. Otherwise, only the primary contact will
          be required to sign
        </v-alert>
        <v-layout align-center class="text-xs-left">
          <v-spacer />
          <v-flex xs4 class="px-2"
            >{{ projectViewEnabled ? 'Project' : 'Questionnaire' }} Notification
            <p class="caption">
              This owner will receive a questionnaire link to complete the
              questionnaire.
            </p></v-flex
          >
          <v-flex xs4 class="px-2"
            >{{ projectViewEnabled ? 'Project' : 'Questionnaire' }} Signature
            <p class="caption">
              This owner will be required to sign all signatures on
              {{ projectViewEnabled ? 'projects' : 'questionnaires' }} with "Get
              All Owners' Signature" on.
            </p></v-flex
          >
        </v-layout>
        <v-layout
          v-for="owner in ownersWithNotifications"
          column
          class="text-xs-left pa-2"
        >
          <v-layout>
            <v-flex xs4>
              {{ owner.full_name }}
              <v-chip
                v-if="currentCompany.user.id === owner.id"
                small
                color="primary"
                text-color="white"
                dark
                >Primary</v-chip
              >
              <v-chip
                v-if="findAssignment(owner).role === 'spouse'"
                small
                color="primary"
                text-color="white"
                dark
                >Spouse</v-chip
              >
              <v-chip
                v-if="!owner.paying"
                small
                color="error"
                text-color="white"
                dark
                >Inactive</v-chip
              >
            </v-flex>
            <v-flex xs4>
              <v-switch
                :label="owner.receive_questionnaire ? 'On' : 'Off'"
                hide-details
                class="pt-0 mt-0"
                :disabled="!owner.paying"
                v-model="owner.receive_questionnaire"
              />
            </v-flex>
            <v-flex xs4>
              <v-switch
                :label="owner.sign_questionnaire_signature ? 'On' : 'Off'"
                hide-details
                class="pt-0 mt-0"
                :disabled="!owner.paying"
                v-model="owner.sign_questionnaire_signature"
              />
            </v-flex>
          </v-layout>
        </v-layout>
        <div v-if="!atLeastOneOwnerHasNotification" class="error--text mt-4">
          Please select at least one owner to receive each notification.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!atLeastOneOwnerHasNotification"
          class="primary text-capitalize"
          @click="saveOwnerNotifications()"
        >
          Save
        </v-btn>
        <v-btn
          class="error--text text-capitalize"
          outline
          @click="closeDialog()"
        >
          cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import FirmPreferenceMixins from '../../mixins/FirmPreferenceMixins';

export default {
  name: 'OwnerNotificationDialog',
  props: {
    currentCompany: {
      type: Object,
    },
    opened: {
      required: true,
      type: Boolean,
    },
  },

  data() {
    return {
      ownersWithNotifications: [],
    };
  },

  mixins: [FirmPreferenceMixins],

  computed: {
    ...mapState('companies', ['companies', 'loadingCompanies']),
    ...mapGetters({
      currentUser: 'user',
    }),
    atLeastOneOwnerHasNotification() {
      return (
        this.ownersWithNotifications.some(
          owner => owner.receive_questionnaire,
        ) &&
        this.ownersWithNotifications.some(
          owner => owner.sign_questionnaire_signature,
        )
      );
    },
  },

  methods: {
    isEmpty,
    findAssignment(owner) {
      return owner.assignments.find(
        assignment => assignment.company_id === this.currentCompany.id,
      );
    },
    closeDialog() {
      this.$emit('refresh');
      this.$emit('update:opened', false);
    },
    async reset() {
      this.ownersWithNotifications = this.currentCompany.owners.map(owner => {
        return {
          ...owner,
          receive_questionnaire: this.findAssignment(
            owner,
          ).notification_type_ids.includes(4),
          sign_questionnaire_signature: this.findAssignment(
            owner,
          ).notification_type_ids.includes(5),
        };
      });
    },
    async saveOwnerNotifications() {
      const response = await API.company.saveOwnerNotifications({
        entityId: this.currentCompany.id,
        ownersWithNotifications: this.ownersWithNotifications,
      });
      if (response.data.error) {
        console.log(response.data.error);
        this.$store.dispatch('application/setErrorNotification', {
          message: response.data.error,
        });
      } else {
        this.$store.dispatch('application/setSuccessNotification', {
          message: 'Successfully saved.',
        });
        this.closeDialog();
        this.$emit('refresh', true);
      }
    },
  },
  watch: {
    opened: {
      handler(value) {
        if (value) {
          this.reset();
        }
      },
    },
  },
};
</script>

<style scoped></style>
